/**
 * Converts an order/visit duration entered in minutes (which may be a decimal,
 * e.g. 2.5) into whole seconds for the planning engine.
 *
 * Rounds to the nearest second so a decimal-minute input never produces a
 * fractional-second value.
 */
const convertDurationToSeconds = (durationMinutes: number): number => Math.round(durationMinutes * 60);

export default convertDurationToSeconds;
